import { type RouteRecordRaw } from 'vue-router';

import { License } from '../../models';

export const schedulingRoutes: RouteRecordRaw[] = [{
    path: 'scheduling/plannings',
    name: 'plannings',
    redirect: { name: 'plannings.plannings' },
    meta: {
        showInMenu: true,
        hasTabs: true,
        categoryIndex: 4,
        index: 1,
        licenses: {
            operator: 'or',
            licenses: [License.SPOT_AUDIO, License.SPOT_SCENT, License.SPOT_VIDEO]
        },
        prependIcon: 'icon-schedule',
        code: 'playdoo.routes.menu.plannings'
    },
    component: () => import('./views/PlanningsView.vue'),
    children: [{
        path: 'plannings/:planningId/edit',
        name: 'plannings.edit-planning',
        meta: {
            code: 'playdoo.routes.plannings.edit-planning',
            hideTabs: true,
            breadcrumbs: true,
            query: ['scheduleKind']
        },
        component: () => import('./views/plannings/EditPlanningView.vue')
    }, {
        path: 'plannings/:planningId/:timeFrame/:date',
        name: 'plannings.planning',
        meta: {
            code: 'playdoo.routes.plannings.planning',
            hideTabs: true,
            breadcrumbs: true,
            query: ['scheduleKind']
        },
        component: () => import('./views/plannings/PlanningView.vue')
    }, {
        path: 'children/:planningId/:timeFrame/:date',
        name: 'plannings.children-planning',
        meta: {
            code: 'playdoo.routes.plannings.children-planning',
            hideTabs: true,
            breadcrumbs: true,
            query: ['scheduleKind']
        },
        component: () => import('./views/plannings/ChildrenPlanningView.vue')
    }, {
        path: 'weeks/:planningId/:weekId',
        name: 'plannings.week',
        meta: {
            code: 'playdoo.routes.plannings.week',
            hideTabs: true,
            breadcrumbs: true
        },
        component: () => import('./views/weeks/WeekView.vue')
    }, {
        path: 'shared/weeks/:planningId/:weekId',
        name: 'plannings.shared-week',
        meta: {
            code: 'playdoo.routes.plannings.shared-week',
            hideTabs: true,
            breadcrumbs: true
        },
        component: () => import('./views/weeks/WeekView.vue')
    }, {
        path: 'children/weeks/:planningId/:weekId',
        name: 'plannings.children-week',
        meta: {
            code: 'playdoo.routes.plannings.children-week',
            hideTabs: true,
            breadcrumbs: true
        },
        component: () => import('./views/weeks/WeekView.vue')
    }, {
        path: 'plannings',
        name: 'plannings.plannings',
        meta: {
            showInTabs: true,
            index: 0,
            code: 'playdoo.routes.plannings.plannings',
            query: ['scheduleKind', 'scopeToggle']
        },
        component: () => import('./views/plannings/PlanningsView.vue')
    }, {
        path: 'shared/:planningId/:timeFrame/:date',
        name: 'plannings.shared-planning',
        meta: {
            code: 'playdoo.routes.plannings.shared-planning',
            hideTabs: true,
            breadcrumbs: true,
            query: ['scheduleKind']
        },
        component: () => import('./views/plannings/SharedPlanningView.vue')
    }, {
        path: 'shared/:planningId/edit',
        name: 'plannings.edit-shared-planning',
        meta: {
            code: 'playdoo.routes.plannings.edit-shared-planning',
            hideTabs: true,
            breadcrumbs: true,
            query: ['scheduleKind']
        },
        component: () => import('./views/plannings/EditSharedPlanningView.vue')
    }, {
        path: 'shared',
        name: 'plannings.shared',
        meta: {
            showInTabs: true,
            index: 1,
            code: 'playdoo.routes.plannings.shared',
            query: ['scheduleKind']
        },
        component: () => import('./views/plannings/SharedView.vue')
    }, {
        path: 'favorites',
        name: 'plannings.favorites',
        meta: {
            showInTabs: true,
            index: 2,
            code: 'playdoo.routes.plannings.favorites',
            query: ['scheduleKind']
        },
        component: () => import('./views/plannings/FavoritesView.vue')
    }]
}, {
    path: 'scheduling/events',
    name: 'events',
    redirect: { name: 'events.events' },
    meta: {
        showInMenu: true,
        hasTabs: true,
        categoryIndex: 4,
        index: 2,
        licenses: {
            operator: 'or',
            licenses: [License.SPOT_AUDIO, License.SPOT_SCENT, License.SPOT_VIDEO]
        },
        prependIcon: 'icon-event',
        code: 'playdoo.routes.menu.events'
    },
    component: () => import('./views/EventsView.vue'),
    children: [{
        path: 'events/:eventId/edit',
        name: 'events.edit-event',
        meta: {
            code: 'playdoo.routes.events.edit-event',
            hideTabs: true,
            breadcrumbs: true,
            query: ['scheduleKind']
        },
        component: () => import('./views/events/EditEventView.vue')
    }, {
        path: 'events/:eventId/:timeFrame/:date',
        name: 'events.event',
        meta: {
            code: 'playdoo.routes.events.event',
            hideTabs: true,
            breadcrumbs: true,
            query: ['scheduleKind']
        },
        component: () => import('./views/events/EventView.vue')
    }, {
        path: 'children/:eventId/:timeFrame/:date',
        name: 'events.children-event',
        meta: {
            code: 'playdoo.routes.events.children-event',
            hideTabs: true,
            breadcrumbs: true,
            query: ['scheduleKind']
        },
        component: () => import('./views/events/ChildrenEventView.vue')
    }, {
        path: 'events',
        name: 'events.events',
        meta: {
            showInTabs: true,
            index: 0,
            code: 'playdoo.routes.events.events',
            query: ['scheduleKind', 'scopeToggle']
        },
        component: () => import('./views/events/EventsView.vue')
    }, {
        path: 'shared/:eventId/:timeFrame/:date',
        name: 'events.shared-event',
        meta: {
            code: 'playdoo.routes.events.shared-event',
            hideTabs: true,
            breadcrumbs: true,
            query: ['scheduleKind']
        },
        component: () => import('./views/events/SharedEventView.vue')
    }, {
        path: 'shared/:eventId/edit',
        name: 'events.edit-shared-event',
        meta: {
            code: 'playdoo.routes.events.edit-shared-event',
            hideTabs: true,
            breadcrumbs: true,
            query: ['scheduleKind']
        },
        component: () => import('./views/events/EditSharedEventView.vue')
    }, {
        path: 'shared',
        name: 'events.shared',
        meta: {
            showInTabs: true,
            index: 1,
            code: 'playdoo.routes.events.shared',
            query: ['scheduleKind']
        },
        component: () => import('./views/events/SharedView.vue')
    }, {
        path: 'favorites',
        name: 'events.favorites',
        meta: {
            showInTabs: true,
            index: 2,
            code: 'playdoo.routes.events.favorites',
            query: ['scheduleKind']
        },
        component: () => import('./views/events/FavoritesView.vue')
    }]
}, {
    path: 'scheduling/broadcast',
    name: 'broadcast',
    meta: {
        showInMenu: true,
        categoryIndex: 4,
        index: 3,
        licenses: {
            operator: 'or',
            licenses: [License.SPOT_AUDIO, License.SPOT_SCENT, License.SPOT_VIDEO]
        },
        prependIcon: 'icon-broadcast',
        code: 'playdoo.routes.menu.broadcast',
        query: ['scheduleKind', 'schedulable', 'schedulableId']
    },
    component: () => import('./views/BroadcastView.vue')
}, {
    path: 'scheduling/statistics',
    name: 'statistics',
    redirect: { name: 'statistics.plannings' },
    meta: {
        showInMenu: true,
        hasTabs: true,
        categoryIndex: 4,
        index: 4,
        licenses: {
            operator: 'or',
            licenses: [License.SPOT_AUDIO, License.SPOT_SCENT, License.SPOT_VIDEO]
        },
        prependIcon: 'icon-pie',
        code: 'playdoo.routes.menu.statistics'
    },
    component: () => import('./views/StatisticsView.vue'),
    children: [{
        path: 'plannings',
        name: 'statistics.plannings',
        meta: {
            showInTabs: true,
            index: 0,
            code: 'playdoo.routes.statistics.plannings',
            query: ['scheduleKind']
        },
        component: () => import('./views/statistics/PlanningsView.vue')
    }, {
        path: 'events',
        name: 'statistics.events',
        meta: {
            showInTabs: true,
            index: 1,
            code: 'playdoo.routes.statistics.events',
            query: ['scheduleKind']
        },
        component: () => import('./views/statistics/EventsView.vue')
    }, {
        path: 'contents',
        name: 'statistics.contents',
        meta: {
            showInTabs: true,
            index: 2,
            code: 'playdoo.routes.statistics.contents'
        },
        component: () => import('./views/statistics/ContentsView.vue')
    }]
}];